import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import IBroker from '~Api/Broker/IBroker';
import WhitelabelTypeEnum from '~Api/Broker/WhitelabelTypeEnum';

interface WhitelabelConfig {
    color: string;
    label: string;
}

const whitelabelTagConfig: Record<WhitelabelTypeEnum, WhitelabelConfig> = {
    [WhitelabelTypeEnum.Gemtree]: { color: 'gold', label: 'Gemtree' },
};

export default function WhitelabelTag(props: {
    broker: IBroker;
}): ReactElement {
    const { broker } = props;

    const config: WhitelabelConfig = whitelabelTagConfig[broker.whitelabelType] ?? null;

    if (!config) {
        return null;
    }

    return (
        <Tag color={config.color}>{config.label}</Tag>
    );
}